﻿import React, { Fragment } from 'react';

export const ColumnList = (props) => {
  const wrappingClass = ['single-step__column-list', props.class].join(' ');

  if (!props.rows || props.rows.length === 0)
    return <Fragment></Fragment>;

  const removeClickHandler = (index) => {
    props.removeCallback(index);
  }

  let headingElement = props.rows[0].heading ? props.rows[0] : null;
  
  return (
    <div className={wrappingClass}>
      {
        props.rows.filter(row => row !== null).map((row, index) => {
          return (
            <Fragment key={index}>
              {row.one && <div className={row.heading ? "one heading" : "one"}>{row.one}</div>}
              {row.two && <div className={row.heading ? "two heading" : "two"}>{row.two}</div>}
              {row.three && <div className={row.heading ? "three heading" : "three"}><span>{headingElement.three}</span>{row.three}</div>}
              {row.four && <div className={row.heading ? "four heading" : "four"}><span>{headingElement.four}</span>{row.four}</div>}
              {row.five && <div className={row.heading ? "five heading" : "five"}><span>{headingElement.five}</span>{row.five}</div>}
              {row.six && <div className={row.heading ? "six heading" : "six"}><span>{headingElement.six}</span>{row.six}</div>}
              {row.remove && <div className="remove remove--desktop"><button disabled={props.disabled} onClick={() => removeClickHandler(headingElement ? index - 1 : index)}>{row.remove}</button></div>}
              {row.under?.length > 0 && <p className="under">{row.under.map(item => { return item.heading && (<Fragment key={item.heading}><span>{item.heading}</span>{item.text}</Fragment>) })}</p>}
              {row.remove && <div className="remove remove--mobile"><button disabled={props.disabled} onClick={() => removeClickHandler(headingElement ? index - 1 : index)}>{row.remove}</button></div>}
              {row.error && <p className={row.error.heading ? 'error' : 'error success'}>{row.error.heading}<span>{row.error.message}</span></p>}
              {row.break && <div className={row.heading ? "break heading" : "break"}>{row.break}</div>}
            </Fragment>
          )
        })
      }
    </div>
  );
}